import { useOutsideClick } from '@hooks/useOutsideClick';
import { Language } from '@type/common';
import React, { useState, useRef, useMemo } from 'react';
import './LanguageSelect.scss';

interface LanguageSelectProps {
  title: string;
  name: string;
  selectFunction: (item: Language) => void;
  list: Language[];
  arrow?: string;
}

export const LanguageSelect = ({
  title,
  name,
  selectFunction,
  list,
  arrow = 'down',
}: LanguageSelectProps) => {
  const [isShowing, setIsShowing] = useState<boolean>(false);

  const selectRef = useRef<HTMLDivElement>(null);
  const handleClickOutside = () => {
    setIsShowing(false);
  };
  useOutsideClick(selectRef, handleClickOutside);

  const handleClick = () => {
    setIsShowing(!isShowing);
  };

  const onSelect = (item: Language) => {
    selectFunction(item);
    setIsShowing(false);
  };

  const listItems = useMemo(() => {
    return list
      ? list.map((item, key) => (
          <li key={key} onClick={() => onSelect(item)}>
            {item[name]}
          </li>
        ))
      : [];
  }, [list, name]);

  return (
    <div ref={selectRef} className='c-language-select'>
      <div className='c-language-select-wrapper' onClick={handleClick}>
        <span>{title}</span>
        {arrow === 'down' || isShowing ? (
          <i className='icon-angle-down' />
        ) : (
          <i className='icon-angle-right' />
        )}
      </div>
      {isShowing && (
        <div className='c-language-select-list'>
          <ul>{listItems}</ul>
        </div>
      )}
    </div>
  );
};
